import { svg, esc } from '../ui/icons.js';
import { dados, estadoEmpresa, ESTADO_EMPRESA, progressoEmpresa, mesDeReferencia } from '../state.js';
import { competenciaExtenso } from '../lib/supabase.js';
import * as Empresas from '../data/empresas.js';
import { SITUACOES } from '../data/empresas.js';
import * as Fechamento from '../data/fechamento.js';
import { usuario, ehGestao } from '../auth.js';
import { abrirFicha } from './ficha.js';

/**
 * Lista de empresas, cadastro e importação por planilha.
 * O protótipo salvava em localStorage('tarter_empresas_extra') — ou seja,
 * a empresa que o Ademir cadastrasse não existia para o Cleytson.
 */

let aoMudarDados = () => {};

// Com 170 empresas, desenhar a tabela inteira a cada tecla digitada trava
// a busca. Mostra um bloco por vez; os filtros continuam valendo sobre o total.
const POR_PAGINA = 50;
let mostrando = POR_PAGINA;

export function configurar({ onChange }) {
  aoMudarDados = onChange || (() => {});

  ['empSearch'].forEach((id) =>
    document.getElementById(id).addEventListener('input', () => { mostrando = POR_PAGINA; render(); })
  );
  ['empFilterRegime', 'empFilterStatus', 'empFilterSituacao', 'empFilterTipo', 'empFilterResp'].forEach((id) =>
    document.getElementById(id).addEventListener('change', () => { mostrando = POR_PAGINA; render(); })
  );

  document.getElementById('btnNovaEmpresa').addEventListener('click', abrirCadastro);
  document.getElementById('cadastroClose').addEventListener('click', fecharCadastro);
  document.getElementById('cadastroScrim').addEventListener('click', fecharCadastro);
  document.getElementById('cadAddItem').addEventListener('click', () =>
    document.getElementById('cadItensList').appendChild(linhaItem())
  );
  document.getElementById('cadSalvar').addEventListener('click', salvar);

  configurarVisao();
  configurarImportacao();
}

/*
 * Quem responde por quê.
 *
 * A coluna Responsável já existia, mas só para leitura — para saber quais
 * são as empresas do Ademir era preciso correr os olhos pelas 124 linhas.
 * O select é preenchido na primeira renderização, quando os colaboradores
 * já chegaram do banco.
 */
function preencherResponsaveis() {
  const sel = document.getElementById('empFilterResp');
  if (!sel || sel.options.length > 1 || !dados.colaboradores.length) return;
  const atual = sel.value;
  sel.innerHTML = '<option value="">Todos os responsáveis</option>'
    + dados.colaboradores.map((c) => `<option value="${c.id}">${esc(c.nome)}</option>`).join('')
    + '<option value="__sem">Sem responsável</option>';
  sel.value = atual;
}

export function render() {
  preencherResponsaveis();
  const responsavel = document.getElementById('empFilterResp')?.value || '';
  const regime = document.getElementById('empFilterRegime').value;
  const status = document.getElementById('empFilterStatus').value;
  const situacao = document.getElementById('empFilterSituacao').value;
  const busca = document.getElementById('empSearch').value.toLowerCase();

  // Vazio = o dia a dia: ativos e sem movimento, sem os ex-clientes no meio.
  const passaSituacao = (e) =>
    situacao === 'todos' ? true
    : situacao ? e.situacao === situacao
    : e.situacao !== 'encerrado';

  /*
   * Filial e só-cadastro existem no sistema para o CNPJ ser consultável e
   * para a contagem bater com o Domínio, mas ninguém trabalha nelas. A
   * tela mostrava as 163 misturadas, e as filiais ainda entravam como
   * "concluído" — não têm competência, então nada fica em aberto.
   *
   * O padrão agora é só quem gera trabalho; as outras continuam
   * acessíveis pelo filtro.
   */
  const tipo = document.getElementById('empFilterTipo').value;
  const ehFilial = (e) => !!e.matriz_id;
  const ehSoCadastro = (e) => e.gera_fechamento === false;
  const passaTipo = (e) =>
    tipo === 'todas' ? true
    : tipo === 'filiais' ? ehFilial(e)
    : tipo === 'so_cadastro' ? ehSoCadastro(e)
    : !ehFilial(e) && !ehSoCadastro(e);

  const passaResponsavel = (e) =>
    !responsavel ? true
    : responsavel === '__sem' ? !(e.responsaveis || []).length
    : (e.responsaveis || []).some((r) => r.id === responsavel);

  const lista = dados.empresas.filter((e) =>
    passaTipo(e) &&
    passaSituacao(e) &&
    passaResponsavel(e) &&
    (!regime || e.regime === regime) &&
    (!status || estadoEmpresa(e) === status) &&
    (e.nome.toLowerCase().includes(busca) || (e.cnpj || '').includes(busca))
  );

  const noUniverso = dados.empresas.filter((e) => passaTipo(e) && passaSituacao(e)).length;

  /*
   * As duas visões partilham os mesmos filtros de propósito: a pergunta
   * real costuma ser "como estão as do Ademir", não "como estão as 124".
   * O quadro mostra todas as filtradas, sem paginar — quem abriu o quadro
   * quer bater o olho no conjunto.
   */
  document.getElementById('empSecaoLista').hidden = visao !== 'lista';
  document.getElementById('empSecaoFrentes').hidden = visao !== 'frentes';
  if (visao === 'frentes') {
    document.getElementById('empCountSub').textContent =
      `${lista.length} de ${noUniverso} · ${dados.empresas.length} no cadastro`;
    renderFrentesLista(lista);
    return;
  }

  const visiveis = lista.slice(0, mostrando);
  document.getElementById('empCountSub').textContent =
    (lista.length > visiveis.length ? `mostrando ${visiveis.length} de ${lista.length}` : `${lista.length} de ${noUniverso}`)
    + ` · ${dados.empresas.length} no cadastro`;

  document.querySelector('#empTable tbody').innerHTML = lista.length
    ? visiveis.map((e) => {
        const [tag, rotulo] = ESTADO_EMPRESA[estadoEmpresa(e)];
        const s = estadoEmpresa(e);
        const extra = s === 'a_realizar' ? ` (${e.pendencias})`
          : s === 'andamento' ? ` ${progressoEmpresa(e)}%` : '';
        const resp = (e.responsaveis || []).map((r) => r.nome).join(', ') || '—';
        const sit = SITUACOES[e.situacao] || SITUACOES.ativo;
        const filial = e.matriz_id
          ? ` <span class="tag blue">Filial${e.matriz?.nome ? ' de ' + esc(e.matriz.nome) : ''}</span>`
          : '';
        const marca = e.situacao === 'encerrado'
          ? ` <span class="tag red">Ex-cliente${e.cliente_ate ? ' desde ' + new Date(e.cliente_ate + 'T00:00').toLocaleDateString('pt-BR') : ''}</span>`
          : e.situacao === 'sem_movimento' ? ' <span class="tag amber">Sem movimento</span>' : '';
        return `<tr class="row-click ${e.situacao === 'encerrado' ? 'linha-encerrada' : ''}" data-emp="${e.id}">
          <td><b>${esc(e.nome)}</b>${filial}${marca}<div style="font-size:11.5px;color:var(--text-muted);">${esc(e.cnpj || '—')}</div></td>
          <td>${esc(e.regime || '—')}</td><td>${esc(resp)}</td>
          <td>${e.situacao === 'encerrado' ? '<span class="tag red">Encerrado</span>' : `<span class="tag ${tag}">${rotulo}${extra}</span>`}</td>
          <td style="text-align:right;">${svg('chev', 16)}</td></tr>`;
      }).join('')
    : `<tr><td colspan="5" style="color:var(--text-muted);">Nenhuma empresa encontrada com esses filtros.</td></tr>`;

  if (lista.length > visiveis.length) {
    const corpo = document.querySelector('#empTable tbody');
    const linha = document.createElement('tr');
    linha.innerHTML = `<td colspan="5" style="text-align:center;padding:14px;">
      <button class="btn" type="button" id="empMostrarMais">Mostrar mais ${Math.min(POR_PAGINA, lista.length - visiveis.length)}</button>
    </td>`;
    corpo.appendChild(linha);
    linha.querySelector('#empMostrarMais').addEventListener('click', () => {
      mostrando += POR_PAGINA;
      render();
    });
  }

  document.querySelectorAll('#empTable tbody tr[data-emp]')
    .forEach((r) => r.addEventListener('click', () => abrirFicha(r.dataset.emp)));
}

/* ------------------------------------------------------------------ */
/* Cadastro                                                            */
/* ------------------------------------------------------------------ */

function linhaItem(nome = '') {
  const linha = document.createElement('div');
  linha.className = 'cad-item-row';
  linha.innerHTML =
    `<input class="cad-input" placeholder="Nome do item (ex.: Fiscal, Banco Itaú...)" value="${esc(nome)}">` +
    `<button type="button">${svg('trash', 15)}</button>`;
  linha.querySelector('button').addEventListener('click', () => linha.remove());
  return linha;
}

function abrirCadastro() {
  const sel = document.getElementById('cadResponsavel');
  sel.innerHTML = dados.colaboradores
    .map((c) => `<option value="${c.id}" ${c.id === usuario().id ? 'selected' : ''}>${esc(c.nome)}</option>`)
    .join('');

  ['cadCodigo', 'cadCnpj', 'cadNome', 'cadRespCliente', 'cadEmail', 'cadZappy']
    .forEach((id) => { document.getElementById(id).value = ''; });

  const lista = document.getElementById('cadItensList');
  lista.innerHTML = '';
  lista.appendChild(linhaItem('Fiscal'));
  lista.appendChild(linhaItem('Banco'));

  document.getElementById('cadastroScrim').classList.add('show');
  document.getElementById('cadastroPanel').classList.add('show');
}

function fecharCadastro() {
  document.getElementById('cadastroScrim').classList.remove('show');
  document.getElementById('cadastroPanel').classList.remove('show');
}

async function salvar() {
  const nome = document.getElementById('cadNome').value.trim();
  if (!nome) { document.getElementById('cadNome').focus(); return; }

  const botao = document.getElementById('cadSalvar');
  botao.disabled = true;
  const rotuloOriginal = botao.textContent;
  botao.textContent = 'Salvando…';

  const respCliente = document.getElementById('cadRespCliente').value.trim();
  const itens = [...document.querySelectorAll('#cadItensList input')]
    .map((i) => i.value.trim()).filter(Boolean);

  try {
    const empresa = await Empresas.criar({
      codigo: document.getElementById('cadCodigo').value.trim() || null,
      cnpj: document.getElementById('cadCnpj').value.trim() || null,
      nome,
      regime: document.getElementById('cadRegime').value,
      email: document.getElementById('cadEmail').value.trim() || null,
      zappy: document.getElementById('cadZappy').value.trim() || nome,
      particularidades: respCliente ? `Responsável pelos documentos: ${respCliente}.` : null,
      andamento: 'Empresa recém-cadastrada.',
      responsaveis: ehGestao() ? [document.getElementById('cadResponsavel').value] : [usuario().id],
    });

    await criarPrimeiraCompetencia(empresa.id, itens);

    fecharCadastro();
    await aoMudarDados();
  } catch (err) {
    alert('Não foi possível cadastrar a empresa: ' + err.message);
  } finally {
    botao.disabled = false;
    botao.textContent = rotuloOriginal;
  }
}

/** Abre o mês corrente e já cria os itens de conferência informados. */
async function criarPrimeiraCompetencia(empresaId, nomesItens) {
  const hoje = new Date();
  const mes = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-01`;

  await Fechamento.abrirCompetencias(empresaId, mes, mes);
  const fechamento = await Fechamento.fechamentoAtual(empresaId);
  if (!fechamento) return;

  for (const [i, nome] of nomesItens.entries()) {
    await Fechamento.adicionarItem(fechamento.id, { nome, status: 'pendente', ordem: i });
  }
}

/* ------------------------------------------------------------------ */
/* Importação por planilha (CSV)                                       */
/* ------------------------------------------------------------------ */

let previa = [];

function lerCSV(texto) {
  const linhas = texto.split(/\r?\n/).filter((l) => l.trim());
  if (!linhas.length) return [];
  const sep = linhas[0].includes(';') ? ';' : ',';
  const cabecalhos = linhas[0].split(sep).map((h) => h.trim().toLowerCase().replace(/"/g, ''));
  return linhas.slice(1).map((linha) => {
    const celulas = linha.split(sep).map((c) => c.trim().replace(/^"|"$/g, ''));
    const obj = {};
    cabecalhos.forEach((h, i) => { obj[h] = celulas[i] || ''; });
    return obj;
  });
}

function configurarImportacao() {
  document.getElementById('importFile').addEventListener('change', (ev) => {
    const arquivo = ev.target.files[0];
    if (!arquivo) return;

    const leitor = new FileReader();
    leitor.onload = (e) => {
      const porNome = new Map(dados.colaboradores.map((c) => [c.nome.toLowerCase(), c.id]));

      previa = lerCSV(e.target.result).map((r) => ({
        codigo: r.codigo || r['código'] || '',
        cnpj: r.cnpj || '',
        nome: r.nome || r.empresa || '',
        regime: r.regime || 'Simples Nacional',
        responsavelNome: r.responsavel || r['responsável'] || '',
        responsavelId: porNome.get((r.responsavel || r['responsável'] || '').toLowerCase()) || usuario().id,
        email: r.email || r['e-mail'] || '',
        zappy: r.zappy || r.nome || '',
      })).filter((r) => r.nome);

      document.getElementById('importCount').textContent = `${previa.length} empresas encontradas`;
      document.querySelector('#importTable tbody').innerHTML = previa.length
        ? previa.map((r) => `<tr>
            <td>${esc(r.codigo)}</td><td>${esc(r.cnpj)}</td><td>${esc(r.nome)}</td>
            <td>${esc(r.regime)}</td><td>${esc(r.responsavelNome || '—')}</td><td>${esc(r.email)}</td>
          </tr>`).join('')
        : `<tr><td colspan="6" style="color:var(--text-muted);">Nenhuma linha reconhecida — confira se a planilha tem cabeçalho com "nome" (e opcionalmente codigo, cnpj, regime, responsavel, email).</td></tr>`;
      document.getElementById('importPreviewSection').style.display = 'block';
    };
    leitor.readAsText(arquivo, 'UTF-8');
  });

  document.getElementById('importConfirm').addEventListener('click', async (ev) => {
    const botao = ev.currentTarget;
    botao.disabled = true;
    botao.textContent = 'Importando…';
    const falhas = [];

    for (const r of previa) {
      try {
        const empresa = await Empresas.criar({
          codigo: r.codigo || null, cnpj: r.cnpj || null, nome: r.nome,
          regime: r.regime, email: r.email || null, zappy: r.zappy || r.nome,
          responsaveis: ehGestao() ? [r.responsavelId] : [usuario().id],
        });
        await criarPrimeiraCompetencia(empresa.id, ['Fiscal', 'Banco']);
      } catch (err) {
        falhas.push(`${r.nome}: ${err.message}`);
      }
    }

    limparImportacao();
    await aoMudarDados();
    botao.disabled = false;
    botao.textContent = 'Confirmar importação';

    if (falhas.length) {
      alert(`${falhas.length} empresa(s) não foram importadas:\n\n` + falhas.join('\n'));
    }
  });

  document.getElementById('importCancel').addEventListener('click', limparImportacao);
}

function limparImportacao() {
  previa = [];
  document.getElementById('importPreviewSection').style.display = 'none';
  document.getElementById('importFile').value = '';
}

/* ------------------------------------------------------------------ */
/* O quadro por frente                                                 */
/*                                                                     */
/* Ela pediu: "a lista das 124 com a coluna conciliação feita até, para */
/* bater o olho sem abrir uma por uma". É o que substitui o recado.     */
/*                                                                     */
/* Usa os MESMOS filtros da lista — responsável, regime, situação,      */
/* busca — porque a pergunta real costuma ser "como estão as do         */
/* Ademir", não "como estão as 124".                                    */
/* ------------------------------------------------------------------ */

let visao = 'lista';
let frentesPorEmpresa = null;   // carregado sob demanda, uma vez

export function configurarVisao() {
  document.querySelectorAll('.emp-visao button').forEach((b) =>
    b.addEventListener('click', () => {
      visao = b.dataset.visao;
      document.querySelectorAll('.emp-visao button').forEach((x) =>
        x.classList.toggle('ativo', x === b)
      );
      render();
    })
  );
}

/** Quantos meses o mês está atrás da referência. Nulo = nunca começou. */
function atraso(mes, referencia) {
  if (!mes) return null;
  const [a1, m1] = mes.slice(0, 7).split('-').map(Number);
  const [a2, m2] = referencia.slice(0, 7).split('-').map(Number);
  return (a2 - a1) * 12 + (m2 - m1);
}

async function renderFrentesLista(lista) {
  const alvo = document.getElementById('empFrentesWrap');
  if (!alvo) return;

  if (!frentesPorEmpresa) {
    alvo.innerHTML = '<p class="log-vazio">Lendo o checklist de todas as empresas…</p>';
    try {
      frentesPorEmpresa = await Empresas.frentesDeTodas();
    } catch (err) {
      alvo.innerHTML = `<p class="log-vazio">Não consegui ler: ${esc(err.message)}</p>`;
      return;
    }
  }

  const referencia = mesDeReferencia();
  const FRENTES = Empresas.FRENTES;

  // Mais atrasada primeiro: é a lista de quem precisa de atenção, não um
  // cadastro em ordem alfabética.
  const linhas = lista.map((e) => {
    const porNome = new Map((frentesPorEmpresa.get(e.id) || []).map((l) => [l.frente, l]));
    const atrasos = FRENTES.map((f) => atraso(porNome.get(f)?.feita_ate, referencia));
    return {
      empresa: e,
      porNome,
      // Hoje 526 das 620 frentes não começaram, então "não começou" sozinho
      // não ordena nada. Quantas não começaram desempata, e o pior atraso
      // entre as que começaram desempata de novo.
      naoComecou: atrasos.filter((a) => a === null).length,
      pior: atrasos.reduce((m, a) => (a === null ? m : Math.max(m, a)), 0),
    };
  }).sort((a, b) =>
    b.naoComecou - a.naoComecou
    || b.pior - a.pior
    || a.empresa.nome.localeCompare(b.empresa.nome, 'pt')
  );

  document.getElementById('empFrentesCount').textContent = `${linhas.length} empresa(s)`;

  const celula = (l) => {
    if (!l) return '<td class="frente-cel vazia">—</td>';
    if (!l.feita_ate) return '<td class="frente-cel zero">não começou</td>';
    const n = atraso(l.feita_ate, referencia);
    const classe = n <= 0 ? 'ok' : n === 1 ? 'quase' : 'atrasado';
    return `<td class="frente-cel ${classe}">
      ${competenciaCurta(l.feita_ate)}
      ${n > 0 ? `<span class="frente-atraso">${n} mês(es)</span>` : ''}
    </td>`;
  };

  alvo.innerHTML = `
    <div class="table-wrap"><table class="tabela-frentes">
      <thead><tr>
        <th>Empresa</th><th>Responsável</th>
        ${FRENTES.map((f) => `<th>${esc(f)}</th>`).join('')}
      </tr></thead>
      <tbody>
        ${linhas.length ? linhas.map(({ empresa: e, porNome }) => `
          <tr class="row-click" data-emp="${e.id}">
            <td><b>${esc(e.nome)}</b></td>
            <td class="frente-resp">${esc((e.responsaveis || []).map((r) => r.nome).join(', ') || '—')}</td>
            ${FRENTES.map((f) => celula(porNome.get(f))).join('')}
          </tr>`).join('')
          : `<tr><td colspan="${FRENTES.length + 2}" style="color:var(--text-muted);">
               Nenhuma empresa com esses filtros.</td></tr>`}
      </tbody>
    </table></div>
    <p class="frentes-legenda">
      Referência: <b>${competenciaExtenso(referencia)}</b>, o mês que já deveria estar fechado.
      <span class="frente-cel ok">em dia</span>
      <span class="frente-cel quase">1 mês atrás</span>
      <span class="frente-cel atrasado">2 ou mais</span>
      <span class="frente-cel zero">não começou</span>
    </p>`;

  alvo.querySelectorAll('tr[data-emp]').forEach((tr) =>
    tr.addEventListener('click', () => abrirFicha(tr.dataset.emp, 'andamento'))
  );
}

const competenciaCurta = (d) =>
  (d ? `${d.slice(5, 7)}/${d.slice(0, 4)}` : '—');
